module.exports = __webpack_public_path__ + "static/front/img/ship_icon_3.4d77e313.png";